<!--
 * @Author: QWX
 * @Description:付款记录列表
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-09 10:45:39
-->
<template>
  <el-table :data="paymentTableData" max-height="370px" stripe class="m-b-8">
    <el-table-column type="index" label="序号" width="50px"></el-table-column>
    <el-table-column label="付款单号"  prop="payCode"></el-table-column>
    <el-table-column :label="item"   v-for="item in currencyColumns" :key="item">
      <template slot-scope="{row}">
        {{currencyFilter(row.payMoney, item)}}
      </template>
    </el-table-column>
    <el-table-column label="提交时间"  prop="createTime">
      <template slot-scope="{row}">
        <span>{{dayjs(row.createTime).format('YYYY-MM-DD hh:mm:ss')}}</span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" >
      <template slot-scope="scope">
        <el-link type="primary" @click="openPaymentDetail(scope.row)">
          查看
        </el-link>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import payRecordView from '@/components/dialog/payRecordView'
import dayjs from 'dayjs'
export default {
  props: {
    paymentTableData: {
      type: Array,
      default: () => []
    },
    currencyColumns: {
      type: Array,
      default: () => []
    },
    accountMoney: {
      type: Array,
      default: () => []
    },
    isRecord: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dayjs
    }
  },
  methods: {
    /**
     * @description: 付款记录列表处理 金额
     * @param {*} payMoney
     * @param {*} item
     * @return {*}
     */
    currencyFilter(payMoney, item) {
      const obj = payMoney.find(i => i.currencyCh === item)
      return obj && this.$zl.util.splitK(obj.money)
    },
    /**
     * @description: 实际付款记录详情弹窗
     * @param {*}
     * @return {*}
     */
    openPaymentDetail(row) {
      const apiMap = this.isRecord ? {
        purchaser: 'getPaymentLSByPaymentId',
        supplier: 'getPaymentLSByPaymentId'
      } : {
        purchaser: 'getPaymentByPaymentId',
        supplier: 'getPaymentByPaymentIdGys'
      }
      this.$zl.dialog.openFull(payRecordView, { accountMoney: this.accountMoney, id: row.id, api: apiMap[this.$store.state.system] }).then((res) => {
      })
    }
  }
}
</script>
